function validationEmail(value) {
    // value = value.replace( /(^[-_+@])|([\s()_/|\\"'`!#$%^&*=+])/ , "" )
    value = value.replace( /(^[^a-zA-Z0-9\p{sc=Cyrillic}])|([^-a-zA-Z0-9\p{sc=Cyrillic}@.])/ , "" )
    
    if ( value.match(/^[-\p{sc=Cyrillic}a-zA-Z0-9.]{1,}@[-\p{sc=Cyrillic}a-zA-Z0-9.]{1,}\.[\p{sc=Cyrillic}a-zA-Z0-9]{2,3}$/) ) {
        this.emailValid = true
    } else {
        this.emailValid = false
    }

    this.email = value
}

function validationTel(value, oldValue) {
    value = value.replace( /[^+-\s()0-9]/ , "" )

    if ( oldValue && oldValue.length > value.length ) {
        if ( value && value.match(/\d/g)?.length === 11 ) {
            this.telValid = true
        } else {
            this.telValid = false
        }
        return
    }
    
    value = value.replace( /^(7)$/ , "+7 (" )
    value = value.replace( /^([3489])/ , "+7 ($1" )
    value = value.replace( /^([01256])/ , "+7 (812) $1" )
    value = value.replace( /^(\+7)$/ , "+7 (" )
    value = value.replace( /(\(\d{3})$/ , "$1) " )
    value = value.replace( /\)\s?(\d{3})$/, ") $1-")
    
    this.tel = value
    
    if ( value && value.match(/\d/g)?.length == 11 ) {
        // console.log('validation OK')
        this.telValid = true
    } else {
        this.telValid = false
    }
}

function validationName(value) {
    value = value.replace( /[^\p{sc=Cyrillic}\sa-zA-Z]/ug , "" )
    value = value.replace( /\s\s/g , " " )
    if ( value && value.match(/./gu).length >= 3 ) {
        this.nameValid = true
    } else {
        this.nameValid = false
    }
    this.name = value
}

function validationComp(value) {
    value = value.replace( /\s\s/g , " " )
    if ( value && value.match(/./gu).length >= 3 ) {
        this.compValid = true
    } else {
        this.compValid = false
    }
    this.comp = value
}
export { validationEmail, validationName, validationTel, validationComp }